import {Component, Input, OnInit} from '@angular/core';
import {Order} from "app/lib/api";

@Component({
  selector: 'app-invoice-detail-order-adapter',
  templateUrl: './invoice-detail-order-adapter.component.html',
  styleUrls: ['./invoice-detail-order-adapter.component.scss']
})
export class InvoiceDetailOrderAdapterComponent implements OnInit {

  @Input() order: Order;

  constructor() {
  }

  ngOnInit() {
  }

}
